<template>
  <div class="container">
    <p>
      The 15th international meeting on 'Visualizing Biological Data' (VIZBI 2025)
      {{ tense("takes", "took") }} place 8&ndash;11 April in Cambridge UK — and streamed online. The
      meeting {{ tense("features", "featured") }} a one-day
      <router-link to="/2025/Masterclass">masterclass training event</router-link>
      followed by a three-day workshop.
      <!-- Satellite masterclasses {{ tense("take", "took") }} place in
      <a href="https://www.datavismasterclass.org/de/heidelberg">Heidelberg (2 April)</a>
      and <a href="https://www.datavismasterclass.org/fr/paris">Paris (14 April)</a>. -->
      <!-- The event {{ tense("will also be", "were") }} streamed online. -->
    </p>
    <HeroVideoVimeo
      v-if="$route.path.match(/\/2025/)"
      id="1061674315"
      credit="Leonora Martínez-Nuñez" />

    <!-- <HeroVideo
      autoplay
      muted
      loop
      playsinline
      mp4="/2025/Hero.mp4"
      jpg="/2025/Hero.jpg"
      credit="Leonora Martínez-Nuñez" /> -->

    <RegisterNowWrapper v-if="!past" />

    <p>
      VIZBI 2025 {{ tense("will feature", "featured") }} keynotes on the combined use of
      visualization with explainable AI for exploring complex multidimensional data. The meeting
      {{ tense("includes", "included") }} talks from 21 world-leading researchers showcasing
      visualizations transforming how life scientists view data, and driving key advances in
      molecular biology, systems biology, biomedical science, and ecology.
      <!-- Confirmed keynote
      speakers: <a href="https://jku-vds-lab.at/persons/streit">Marc Streit</a> (<i
        >'Explainable AI'</i
      >); <a href="https://giorgialupi.com/about">Giorgia Lupi</a> (<i>'Data-driven storytelling'</i
      >); and <a href="https://tobias.isenberg.cc/">Tobias Isenberg</a> (<i>
        'Interactive data exploration in 2D & 3D'</i
      >). -->
    </p>

    <p>
      The VIZBI meeting {{ tense("brings", "brought") }} together a diverse community, including
      bioinformaticians, data scientists, computer scientists, and experimentalists, as well as
      medical illustrators, graphic designers, and graphic artists.
    </p>
    <!--<p>All participants will have the opportunity to present a <a href="Posters/">poster and lightning talk</a> describing their work.</p> -->
    <p>
      All participants {{ tense("will have", "had") }} the opportunity to present a poster
      <!-- <router-link to="/2025/Posters">poster</router-link> -->
      and lightning talk
      <!-- <router-link :to="{name: 'Posters', hash: '#Lightning'}">lightning talk</router-link>-->
      describing their work. To see examples from previous VIZBIs, please take a look at the
      <router-link to="/Posters/2021">VIZBI poster collection</router-link>.
    </p>
    <!-- <p>
      A post-workshop
      <router-link to="/2025/Showcase">Showcase event</router-link>
      on Friday evening
      {{ tense("will highlight", "highlighted") }} life science communication in film and
      interactive media. -->
    <!-- Further details about the Showcase will be announced
      shortly. -->
    <!-- </p> -->
    <p>
      VIZBI 2025 {{ tense("is set to be", "was") }} an exciting event that
      {{ tense("will help", "helped") }} raise the standard of data visualization in the life
      sciences.
      <span v-if="!past">We hope very much you can join us!</span>
      <span v-else>
        Highlights from the meeting are available on the VIZBI
        <router-link to="/blog">blog</router-link>,
        <router-link to="/posters/2025">posters</router-link>,
        <router-link to="/photos/2025">photos</router-link>, and
        <router-link to="/videos">videos</router-link> pages as well as on our
        <a href="https://twitter.com/vizbi">Twitter timeline</a>.</span
      >
    </p>
    <p v-if="!past">
      If you are interested in promoting your organization or professional society, please contact
      us to discuss sponsorship options.
      <!-- <a href="Sponsors/">sponsorship options</a>. -->
    </p>

    <p>
      Due to unforeseen circumstances, we have postponed the satellite masterclasses planned for
      <a href="https://www.datavismasterclass.org/de/heidelberg">Heidelberg</a>
      and <a href="https://www.datavismasterclass.org/fr/paris">Paris</a>.
    </p>
    <p>
      To receive updates about VIZBI, we encourage you to join the
      <a href="#join" target="_self">VIZBI mailing list</a>.
    </p>
    <KeyDates :items="keyDateItems" />
    <!-- <p><sup>*</sup>Registration for online participation remains open until the event begins.</p> -->
  </div>
</template>

<script setup>
const log = (msg) => process.env.VUE_APP_DEV && console.log(); // eslint-disable-line
import HeroVideoVimeo from "@/components/HeroVideoVimeo.vue";
// import HeroVideo from "@/components/HeroVideo.vue";
// import HeroImage from "@/components/HeroImage.vue";
import RegisterNowWrapper from "@/components/CallToAction/RegisterNowWrapper";
import KeyDates from "@/components/KeyDates";
import keyDateItems from "./keyDates.json";
import useTense from "@/composables/useTense";
const past = true;
const {tense} = useTense(past);
</script>

<style scoped>
button[aria-label="Play"],
button[aria-label="Pause"] {
  display: none !important;
}
</style>
